var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-5"},[_c('loading',{attrs:{"active":_vm.loading,"is-full-page":false}}),_vm._v(" "),(!_vm.loading)?_c('div',[_c('h4',[_vm._v("Redirigiendo a Mesa de Ayuda...")]),_vm._v(" "),(_vm.error)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }